import React from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';

import BEM from '../../Utilities/BEM/index.jsx';

import Spinner from '../Spinner/index.jsx';


class SubmitButton extends React.Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  onClick(event) {
    if (this.props.onSubmit) {
      event.preventDefault();

      this.props.onSubmit(event);
    }
  }

  render() {
    var variants = [];
    if (this.props.loading) {
      variants.push('loading');
    }

    return (
      <div className={BEM.classString('cs-form-submit', variants)}>
        <Button onClick={this.onClick} disabled={this.props.loading}>
          <span className="cs-form-submit__text">{this.props.children}</span>
          <span className="cs-form-submit__spinner"><Spinner /></span>
        </Button>
      </div>
    );
  }
}



class CheckoutCoupons extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      coupon: '',
      response: null
    };

    this.body = undefined;

    this.onClick = this.onClick.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onSubmitComplete = this.onSubmitComplete.bind(this);
  }

  componentDidMount() {
    this.body = jQuery(document.body);
  }

  onClick(event) {
    this.setState({ loading: true, response: null });

    var ajaxData = 'security=' + this.props.nonce + '&coupon_code=' +
      encodeURIComponent(this.state.coupon);
    var ajaxUrl = this.props.ajaxUrl;

    new Promise(function(resolve, reject) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', ajaxUrl);
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      xhr.onreadystatechange = function() {
        if (this.readyState != 4) {
          return;
        }

        if (this.status == 200) {
          resolve(this.responseText);
        } else {
          reject('API call has failed...');
        }
      };

      xhr.send(ajaxData);
    }).then(this.onSubmitComplete);
  }

  onChange(event) {
    this.setState({ coupon: event.target.value });
  }

  onSubmitComplete(data) {
    // trigger events to match the WooCommerce functionality
    this.body.trigger('applied_coupon_in_checkout', [ this.state.coupon ]);
    this.body.trigger('update_checkout', { update_shipping_method: false });

    // clear the entered coupon code, and display the results.
    this.setState({ loading: false, coupon: '', response: data });
  }

  render() {
    return (
      <div className="my-4">
        <div dangerouslySetInnerHTML={{ __html: this.state.response }} />
        <div className="form-inline align-items-end">
          <Form.Group>
            <Form.Label htmlFor="__coupon_code">
              Have a discount code?
            </Form.Label>
            <Form.Control
              type="text"
              id="__coupon_code"
              placeholder="Enter discount code"
              className="w-100"
              disabled={this.state.loading}
              value={this.state.coupon}
              onChange={this.onChange}
            />
          </Form.Group>
          <Form.Group className="ml-2">
            <SubmitButton loading={this.state.loading} onSubmit={this.onClick}>
              Apply
            </SubmitButton>
          </Form.Group>
        </div>
      </div>
    );
  }
}


export default CheckoutCoupons;

